import {
  domicilioBuilder,
  DomicilioModel
} from 'app/domicilio/models/DomicilioModel';
import {
  AirportDetails,
  Payment,
  TransferReservationType
} from '../../viajeTraslado/models/TransferReservationPartial';
import {
  passengerBuilder,
  PassengerModel
} from 'app/client/clientBusiness/Passenger/models/Passenger';
import moment, { Moment } from 'moment';
import {
  choferPartialBuilder,
  ChoferPartialModel
} from 'app/chofer/models/Chofer';
import { ViajeCanalesDeIngreso, ViajeTrasladoTipoServicio } from 'app/viaje/models';

export enum StatusPayment {
  PAID = 'PAGADO',
  UNPAID = 'IMPAGO',
  PENDING = 'PENDIENTE',
  MANUAL_PAYMENT = 'PAGADO_MANUAL'
}
export interface Rating {
  comment: string | null;
  details: any | null;
}

interface PersonalInfo {
  email: string;
  mailUrl: string;
  phone?: string;
  whatsappUrl?: string;
}

export interface Client {
  id: number;
  name: string;
  hasPriority: boolean;
  type: string;
  company_name: string;
  personalInfo?: PersonalInfo;
}

export enum ParticularTravelStatus {
  CREADA = 1,
  ASIGNADA = 2,
  ACEPTADA = 3,
  EN_VIAJE_A_ORIGEN = 4,
  ANUNCIADO = 5,
  EN_VIAJE_A_DESTINO = 6,
  VIAJE_FINALIZADO = 7,
  AUDITORIA_PENDIENTE = 8,
  AUDITADA_MANUALMENTE = 9,
  AUDITADA_AUTOMATICAMENTE = 10,
  CANCELADO = 11,
  LIQUIDADO = 12,
  FACTURADO = 13,
  PENDIENTE_DE_CONFIRMACION = 14,
  INICIO_ESPERA = 15,
  RECHAZADA_POR_CHOFER = 16
}

export interface ParticularTravel {
  airport_details: AirportDetails;
  assigned_driver: ChoferPartialModel;
  cancellation_reason_client: string | null;
  client: Client;
  discount: number;
  entry_channel: ViajeCanalesDeIngreso;
  estimated_time: number;
  expenses_total: number;
  id: number;
  kilometers: number;
  locations: {
    observation: string;
    minutesWaiting: number;
    address: DomicilioModel;
    passengers: PassengerModel[] | null;
  }[];
  observation_transfer_reservations_app: string | null;
  payment_info: Payment;
  trip_end_time: Moment;
  service: ViajeTrasladoTipoServicio;
  transfer_price: number;
  trip_duration: number;
  uuid: string;
  type: TransferReservationType;
  status: ParticularTravelStatus;
  has_required_bill: boolean;
  has_send_bill: boolean;
}

export interface ParticularTravelsModel {
  rows: ParticularTravel[];
  total: number;
  page: number;
  page_size: number;
}

export interface ParticularTravelsFiltersFormType {
  id: string | null;
  state: ParticularTravelStatus.FACTURADO | false;
  status_payment: StatusPayment | null;
  dateFrom: Moment | null;
  dateTo: Moment | null;
  clientId: number | null;
  has_required_bill: string | null;
  has_send_bill: string | null;
}

export const particularTravelBuilder = {
  fromBackEnd: (particularTravel: any): ParticularTravel => ({
    ...particularTravel,
    assigned_driver: choferPartialBuilder.fromBackEnd(
      particularTravel.assigned_driver
    ),
    trip_end_time: moment(particularTravel.trip_end_time),
    locations: particularTravel.locations.map((location) => ({
      ...location,
      address: domicilioBuilder.fromBackEnd(location.address),
      passengers: location.passengers
        ? location.passengers?.map(passengerBuilder.fromBackEnd)
        : null
    })),
    payment_info: particularTravel.payment_info ? {
      ...particularTravel.payment_info,
      states: particularTravel.payment_info.states.map((s) => ({
        ...s,
        datetime: moment(s.datetime)
      }))
    } : null,
    has_required_bill: particularTravel.has_required_bill === 1 ? true : false,
    has_send_bill: particularTravel.has_send_bill === 1 ? true : false
  })
};

export const formatDate = (date: any) => {
  if (!date) return null;
  const dateTimeWithTz = date.toISOString(true);
  const dateTimeSplited = dateTimeWithTz.split(/[+-]/);
  const dateTime = [
    `${dateTimeSplited[0]}-${dateTimeSplited[1]}-${dateTimeSplited[2]}`,
    ...dateTimeSplited.slice(3, -1)
  ].join('');
  return encodeURIComponent(dateTime + 'Z');
};